import Rest2 from '../Services/Rest2'
import {store} from '../store/store'
/**
 * @typedef {PacatoxService}
 */
export default class PacatoxService{

    constructor() {
        this.resource = "/pacato"
        this.http = Rest2.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    configs() {
        return this.http.get("/configs");
    }
}